module.exports = __webpack_public_path__ + "img/mtq.bfeadb02.svg";